import { FC } from 'react'
import clsx from 'clsx'
import { useHistory } from 'react-router-dom'
import { Icon } from '@iconify/react'
import { useModal } from '@ebay/nice-modal-react'

import { Button } from '@pepper/ui'
import { InsightRedirect } from '../types'

import s from './InsightWrapper.module.css'

type Props = {
  description: string
  cta: string
  redirectUrl: InsightRedirect
  impact: 'high' | 'medium' | 'low'
}

export const InsightWrapper: FC<Props> = ({
  description,
  cta,
  redirectUrl,
  impact,
}) => {
  const history = useHistory()
  const { show: showProjectPicker } = useModal('select-project-modal')

  return (
    <div className={clsx(s.footer, s[impact])}>
      <div className={s.footerDescription}>
        <div className={clsx(s.iconWrapper, s[impact])}>
          <Icon icon="lucide:lightbulb" />
        </div>
        {description}
      </div>
      {cta && redirectUrl && (
        <Button
          type="link"
          icon={<Icon icon="lucide:arrow-right" />}
          iconPlacement="right"
          onClick={() => {
            if (redirectUrl === 'content_refresh') {
              history.push('/content-refresh')
            } else {
              showProjectPicker({
                onAfterSelectId: (projectId: string) => {
                  history.push(`/project/${projectId}/topics`)
                },
              })
            }
          }}
        >
          {cta}
        </Button>
      )}
    </div>
  )
}
